import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { useLanguage } from '@/context/LanguageContext';

export default function FaqSection() {
  const { t } = useLanguage();
  const faq = t.faq;
  if (!faq) return null;

  return (
    <section id="faq" className="bg-white border-b border-ct-line py-20 lg:py-28">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-[1fr_1.4fr] gap-10 lg:gap-16">
          <div>
            <p className="text-[11px] font-bold uppercase tracking-widest text-ct-brand mb-3">
              {faq.subtitle}
            </p>
            <h2
              className="text-3xl sm:text-4xl font-black text-ct-ink tracking-tight mb-4"
              style={{ fontFamily: 'Chivo, sans-serif' }}
            >
              {faq.title}
            </h2>
            <p className="text-sm text-ct-ink-2 leading-relaxed max-w-md">{faq.subcopy}</p>
          </div>

          <div className="border-t border-ct-line">
            <Accordion type="single" collapsible className="w-full">
              {faq.items.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`faq-${i}`}
                  className="border-b border-ct-line"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger
                    className="py-5 text-base font-semibold text-ct-ink hover:no-underline hover:text-ct-brand transition-colors data-[state=open]:text-ct-brand"
                    style={{ fontFamily: 'Chivo, sans-serif' }}
                  >
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-5 pt-0 text-[14px] text-ct-ink-2 leading-relaxed">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
